<template>
  <form class="step step_large" @submit.prevent="submit">
    <div class="step-row separator">
      <div class="step-row__title text_small">{{ i18n.sale_your_fund_type() }}: <span class="text_bold">{{ i18n[getTranslate()]() }}</span></div>
    </div>
    <div class="step-row separator">
      <div class="step-row__title text_small">{{ i18n.sale_campaign_start() }}</div>
      <div class="switcher">
        <md-button
          class="switcher__btn"
          :class="form.startTimeNow ? '' : 'active'"
          @click="form.startTimeNow = false"
        >{{ i18n.sale_start_time_set() }}</md-button>
        <md-button
          class="switcher__btn"
          :class="form.startTimeNow ? 'active' : ''"
          @click="form.startTimeNow = true"
        >{{ i18n.sale_start_time_now() }}</md-button>
      </div>

      <div class="step__inputs-wrap">
        <div v-if="!form.startTimeNow">
          <!--<div class="step-row__title">{{ i18n.lbl_date() }}</div>-->
          <date-field-flatpickr v-model="form.startTime"
                                v-validate="form.startTimeNow ? '' : 'required'"
                                name="sale-open-time"
                                id="sale-open-time"
                                ref="ref_opentime"
                                class="field-calendar field_medium"
                                :label="i18n.lbl_date()"
                                :disableBefore="disableBeforeDate('start')"
                                :disableAfter="form.endTime"
                                :errorMessage="errorMessage('sale-open-time')"
                                :disableCalendar="form.startTimeNow"
                                @date-change-event="compareStartFinish()"
          />
          <div class="field-mask field-time field_medium">
            <label for="startTimeDetail">{{ i18n.lbl_time_optional() }}</label>
            <the-mask v-model="form.startTimeDetail"
                      name="startTimeDetail"
                      id="startTimeDetail"
                      :mask="['##:##']"
                      :masked="true"
                      placeholder="00:00"/>
          </div>
        </div>

        <div class="step-row__title text_small">{{ i18n.sale_campaign_finish() }}</div>

        <div>
          <date-field-flatpickr v-model="form.endTime"
                                v-validate="'required'"
                                name="sale-close-time"
                                id="sale-close-time"
                                ref="ref_endtime"
                                class="field-calendar"
                                :label="i18n.lbl_date()"
                                :disableBefore="disableBeforeDate('end') || new Date().toString()"
                                :errorMessage="errorMessage('sale-close-time')"
          />
          <div class="field-mask field-time field_medium">
            <label for="endTimeDetail">{{ i18n.lbl_time_optional() }}</label>
            <the-mask v-model="form.endTimeDetail"
                      name="endTimeDetail"
                      id="endTimeDetail"
                      :mask="['##:##']"
                      :masked="true"
                      placeholder="23:59"/>
          </div>
        </div>

        <div class="step-row__description text_small">
          <div class="fund-info__description">{{ i18n.sale_campaign_time_description() }}</div>
        </div>
      </div>
    </div>

    <div class="step-row">
      <md-field class="step-row__field field_medium">
        <label for="defaultQuoteAsset">{{ i18n.sale_investment_asset() }}</label>
        <md-select v-model="form.defaultQuoteAsset"
                   name="defaultQuoteAsset"
                   id="defaultQuoteAsset"
                   placeholder="USD"
        >
          <md-option v-for="(val) in availableQuoteAssets" :value="val" :key="val">{{ val }}</md-option>
        </md-select>
      </md-field>

      <div class="step__inputs-wrap">
        <div class="step-row__title text_small">{{ i18n.sale_collection_amount() }}</div>
        <div class="field-wrap">
          <div class="field-icon__wrap">
            <input-field v-model="form.softCap"
                         v-validate="{
                           required:true,
                           amount: true
                          }"
                         class="field_short field__number"
                         name="sale-soft-cap"
                         id="sale-soft-cap"
                         type="number"
                         :label="i18n.sale_soft_cap()"
                         :errorMessage="errorMessage('sale-soft-cap')"
                         @blur="form.softCap = roundCurrency(form.softCap, form.defaultQuoteAsset)"
            />
            <div class="field-icon">{{ CurrencyHelper.getCurrencyIcon(form.defaultQuoteAsset) }}</div>
          </div>
          <div class="field-icon__wrap">
            <input-field v-model="form.hardCap"
                         v-validate="{
                        required:true,
                        amount: true,
                        soft_cap: [form.softCap]
                        }"
                         class="field_short field__number"
                         name="sale-hard-cap"
                         id="sale-hard-cap"
                         type="number"
                         :label="i18n.sale_hard_cap()"
                         :errorMessage="errorMessage('sale-hard-cap')"
                         @blur="form.hardCap = roundCurrency(form.hardCap, form.defaultQuoteAsset)"
            />
            <div class="field-icon">{{ CurrencyHelper.getCurrencyIcon(form.defaultQuoteAsset) }}</div>
          </div>
        </div>
      </div>

      <div class="step-row__description text_small">
        <div>{{ i18n.sale_softcap_description() }}</div>
        <div>{{ i18n.sale_hardcap_description() }}</div>
      </div>

      <div class="field-icon__wrap">
        <input-field v-model="form.min_invest_amount"
                     v-validate="{
                          required:true,
                          amount: true
                         }"
                     class="step__input-field field__number"
                     name="min_invest_amount"
                     id="min_invest_amount"
                     type="number"
                     :label="i18n.sale_minimum_invest()"
                     :errorMessage="errorMessage('min_invest_amount')"
                     @blur="form.min_invest_amount = roundCurrency(form.min_invest_amount, form.defaultQuoteAsset)"
        />
        <div class="field-icon">{{ CurrencyHelper.getCurrencyIcon(form.defaultQuoteAsset) }}</div>
      </div>

      <div class="step-row__title text_small">{{ i18n.sale_available_currencies() }}</div>
      <div class="d-flex">
        <md-checkbox v-for="(val) in availableQuoteAssets"
                     v-model="form.quoteAssets"
                     :value="val"
                     :key="val"
                     class="checkbox-button"
        >
          {{ val }}
        </md-checkbox>
      </div>
      <div class="step-row__description text_small">
        <div>{{ i18n.sale_available_currencies_description() }}</div>
        <div>{{ i18n.sale_available_currencies_description_2() }}</div>
      </div>
    </div>
    <div class="btn-wrap column">
      <md-button type="submit" class="btn md-primary" :disabled="isPending">
        {{ i18n.sale_next_step() }}
      </md-button>
      <md-button @click="stepBack()" class="simple-link arrow_back">
        {{ i18n.lbl_go_back_2() }}
      </md-button>
    </div>
  </form>
</template>

<script>
  import StepMixin from './step.mixin'
  import config from '@conf'
  import { ErrorHandler } from '@js/errors/error_handler'
  import { EventDispatcher } from '@js/events/event_dispatcher'
  import { commonEvents } from '@js/events/common_events'
  import { i18n } from '@js/i18n'
  import _pick from 'lodash/pick'
  import { TheMask } from 'vue-the-mask'
  import { CurrencyHelper } from '@js/helpers/currency.helper'
  import CurrencyRound from '@com/mixins/currency.round.mixin'

  export default {
    name: 'StepGeneralInfo',
    mixins: [StepMixin, CurrencyRound],
    components: { TheMask },
    data: _ => ({
      values: {
        tokens: []
      },
      form: {
        defaultQuoteAsset: config.DEFAULT_QUOTE_ASSET,
        startTime: null,
        startTimeDetail: null,
        startTimeNow: false,
        endTime: null,
        endTimeDetail: null,
        softCap: '',
        hardCap: '',
        quoteAssets: [config.DEFAULT_QUOTE_ASSET],
        enableTimeSpec: false,
        min_invest_amount: null
      },
      availableQuoteAssets: [],
      i18n,
      config,
      CurrencyHelper
    }),

    async created () {
      this.form = _pick(this.sale, Object.keys(this.form))
      this.getQuoteAssets()

      this.$emit(commonEvents.saleProgressUpdate)
      if (!this.form.quoteAssets.length) {
        this.form.quoteAssets = [config.DEFAULT_QUOTE_ASSET]
      }
    },

    methods: {
      getQuoteAssets () {
        this.availableQuoteAssets = config.AVAILABLE_QUOTE_ASSETS
      },
      getTranslate () {
        return 'sale_' + this.sale.internal_type
      },
      stepBack () {
        this.$emit(commonEvents.saleStepBack)
      },
      disableBeforeDate (period) {
        let date = new Date()
        if (period === 'start') {
          date.setDate(date.getDate() - 1)
          return date.toString()
        } else if (period === 'end') {
          if (this.form.startTime !== '') {
            date = new Date(this.form.startTime)
          }
          return date.setDate(date.getDate() - 1)
        }
      },
      compareStartFinish () {
        if (this.form.startTime === this.form.endTime) {
          this.disableBeforeDate('end')
          let stamp = Date.parse(this.form.startTime)
          stamp += 24 * 3600 * 1000
          this.form.endTime = new Date(stamp)
        }
      },
      async submit () {
        if (!await this.isValid()) return
        if (!this.form.quoteAssets.length) {
          EventDispatcher.dispatchShowErrorEvent(i18n.sale_accept_investments())
          return
        }
        if (!this.form.startTimeDetail) {
          this.form.startTimeDetail = '00:00'
        }
        if (!this.form.endTimeDetail) {
          this.form.endTimeDetail = '23:59'
        }
        if (this.form.startTimeDetail || this.form.endTimeDetail) {
          this.form.enableTimeSpec = true
          this.form.startTime += ' ' + this.form.startTimeDetail
          this.form.endTime += ' ' + this.form.endTimeDetail
        }
        this.disable()
        try {
          this.$emit(commonEvents.saleUpdateEvent, {
            form: this.form
          })
        } catch (error) {
          ErrorHandler.processUnexpected(error)
        }
        this.enable()
      }
    }
  }
</script>

<style scoped lang="scss">
  @import './step.scss';
  @import "~scss/mixins";
  @import "~scss/variables";
</style>



// WEBPACK FOOTER //
// src/vue/app/saleCreation/steps/Step.GeneralInfo.vue